import { render, staticRenderFns } from "./AnnotationDetails.vue?vue&type=template&id=57a17362&scoped=true"
import script from "./AnnotationDetails.vue?vue&type=script&lang=js"
export * from "./AnnotationDetails.vue?vue&type=script&lang=js"
import style0 from "./AnnotationDetails.vue?vue&type=style&index=0&id=57a17362&prod&scoped=true&lang=scss"
import style1 from "./AnnotationDetails.vue?vue&type=style&index=1&id=57a17362&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a17362",
  null
  
)

export default component.exports